// extracted by mini-css-extract-plugin
export var cartContainer = "_bt-4";
export var gray = "_bt-1";
export var itemContainer = "_bt-2";
export var itemDetails = "_bt-3";
export var strong = "_bt-0";